import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  MYAPPS: {
    id: 'MyApps.myApps',
    defaultMessage: 'My Apps',
    description: '[Type: Label][Vis.: low] - My Apps link in main navigation',
  },
});

const MyApps = () => {
  const url = createURL('/apps/', { ut_source: 'header' });
  const title = t(COPY.MYAPPS);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.MYAPPS} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.MYAPPS} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default MyApps;
export { MyApps };
